/**
 * Makes a copy of the data structure pointed to by the reference passed as
 * param and returns a reference of the copy, or null if an error occurs (most
 * probably because the data structure is circular).
 * @param {object} object: the reference to the data structure that shall be
 * copied.
 * @return {object|null}: the reference to the copy or null if an error occured.
 */
const getCopy = (reference) => {
  if (typeof reference !== 'object') {
    return null
  }
  try {
    return JSON.parse(JSON.stringify(reference))
  } catch (error) {
    return null
  }
}

const getCopyName = (string, copy) => {
  const stringArray = string.toString().split(`(${copy} `)
  if (stringArray[1]) {
    const size = parseInt(stringArray[1]) + 1
    return `${stringArray[0]}(${copy} ${size})`
  }
  return `${string} (${copy} 1)`
}

export {
  getCopy,
  getCopyName
}



// WEBPACK FOOTER //
// ./src/services/tools.js